import React from 'react';

import {interpolate} from 'topmeteo/utils/i18n';

const BaseDistance = ({id, label, length}) => (
    <div id={id}>
        <p>{interpolate(label, {length})}</p>
    </div>
);

export default BaseDistance;
